import React from "react";

import { SideNavBarV2 } from "../../components";
import { tabs } from "./helper";

const QuoteBuilderNav = ({ value = 1, setValue = () => {} }) => {
  const props = { tabs, value, setValue };
  return <SideNavBarV2 {...props} />;
};

export default QuoteBuilderNav;